// @flow
import React, { PureComponent } from 'react';
import type { ArticleType, CategoryArticleType } from 'types/Article';
import DropdownRadioInput from 'components/fragments/input/DropdownRadioInput';
import { formatFullDate } from 'utils/dateUtils';
import { Link } from 'react-router-dom';
import { getDateFromString } from 'utils/dateUtils';
import BackgroundImage from 'components/fragments/BackgroundImage';

type Props = {
  news: Array<ArticleType>,
  categoriesArticle: Array<CategoryArticleType>
};

type ComponentState = {
  catId: number,
  maxNews: number
};

class BillboardDirect extends PureComponent<Props, ComponentState> {
  state: ComponentState = {
    catId: 0,
    maxNews: 4
  };

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions.bind(this));
  }

  componentDidUpdate() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions.bind(this));
  }

  updateDimensions() {
    const { maxNews } = this.state;
    if (window.innerWidth < 840 && maxNews !== 3) {
      this.setState({ maxNews: 3 });
    }
    if (window.innerWidth >= 840 && maxNews !== 4) {
      this.setState({ maxNews: 4 });
    }
  }
  handleChange = (value: any) => {
    this.setState({
      catId: value
    });
  };

  renderNews() {
    const { news, categoriesArticle } = this.props;
    const { catId, maxNews } = this.state;
    if (catId === 0) {
      return news.map<any>((news, index) => {
        /**
         * La première news est déjà en home
         */
        if (index === 0 || index > maxNews + 1) {
          return null;
        }
        const { illustration, title, label, slug, link, srcset } = news;
        const date = getDateFromString(news.date);
        return (
          <Link
            key={slug}
            to={{
              pathname: link
            }}
            title={`Lire la suite de l'article : ${title}`}
            role="button"
            tabIndex={0}
            className={'news news--row'}
          >
            <article>
              <BackgroundImage
                className="news__thumbnail img-blue"
                illustration={illustration}
                srcset={srcset}
                forceState={'thumbnail'}
              />
              <div>
                <span className="news__title ft-h5">{title}</span>
                <p className="ft-h6">
                  <span className="news__cat ft-up">{label.name}</span>
                  <span className="news__date">{formatFullDate(date)}</span>
                </p>
              </div>
            </article>
          </Link>
        );
      });
    } else {
      return categoriesArticle.map<any>((cat, index) => {
        if (cat.id === catId) {
          return cat.items
            .filter(article => {
              return article.link !== news[0].link;
            })
            .map((news, index) => {
              if (index > 4) {
                return null;
              }
              const { illustration, title, label, slug, link, srcset } = news;
              const date = getDateFromString(news.date);
              return (
                <Link
                  key={slug}
                  to={{
                    pathname: link
                  }}
                  title={`Lire la suite de l'article : ${title}`}
                  role="button"
                  tabIndex={0}
                  className={'news news--row'}
                >
                  <article>
                    <BackgroundImage
                      className="news__thumbnail img-blue"
                      illustration={illustration}
                      srcset={srcset}
                      forceState={'thumbnail'}
                    />
                    <div>
                      <span className="news__title ft-h5">{title}</span>
                      <p className="ft-h6">
                        <span className="news__cat ft-up">{label.name}</span>
                        <span className="news__date">{formatFullDate(date)}</span>
                      </p>
                    </div>
                  </article>
                </Link>
              );
            });
        }
        return null;
      });
    }
  }

  render() {
    const { categoriesArticle } = this.props;
    if (!categoriesArticle || !Array.isArray(categoriesArticle) || categoriesArticle.length == 0) {
      return '';
    }
    const { maxNews, catId } = this.state;
    const categories_options = categoriesArticle.map(cat => {
      return { label: cat.name, value: cat.id };
    });
    categories_options.unshift({ label: maxNews === 4 ? 'Toutes les catégories' : 'Toutes catégories', value: 0 });
    categories_options.forEach((option, index) => {
      if (option.label.length > 25) {
        option.label = option.label.substring(0, 24) + '...';
      }
      return null;
    });

    let dropdownLabel = categories_options[0].label;
    if (catId) {
      const dropdownLabels = categories_options.filter(cat => {
        return cat.value === catId;
      });
      if (dropdownLabels.length > 0) {
        dropdownLabel = dropdownLabels[0].label;
      }
    }
    return (
      <div className="card--news-direct-container">
        <div className="container">
          <div className="card--news-direct">
            <div className="card__head">
              <h3 className="ft-h3">En direct</h3>
              <DropdownRadioInput
                options={categories_options}
                inputChanged={this.handleChange}
                label={dropdownLabel}
                radio={true}
                maj={true}
                title={true}
                noBorder={true}
              />
            </div>

            <div className="box">{this.renderNews()}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default BillboardDirect;
